module.exports = __webpack_public_path__ + "fonts/d90c5b9f5e88e91dfca571dd0f7a7e8d.txt";